/* eslint-disable
    func-names,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all Document.
const deps = ['Document', 'Collection', 'File', '_'];
const factory = function (Document, Collection, FileModel, _) {
  let DocumentCollection;
  return (DocumentCollection = (function () {
    DocumentCollection = class DocumentCollection extends Collection {
      static initClass() {
        this.prototype.$id = null;
        this.prototype.$resource = 'document';
        this.prototype.$type = Document;

        this.prototype.$idSerializers = [
          'clientId',
          'from',
          'to',
          'month',
          'year',
          'page',
          'documentType',
          'ledgerId',
          'addOnId',
          'archived',
          'fileName',
        ];

        this.prototype.$paramNames = {
          from: 'from',
          to: 'to',
          month: 'month',
          year: 'year',
          ledgerId: 'ledgerId',
          addOnId: 'addOnId',
          page: 'page',
          resultsPerPage: 'resultsPerPage',
          archived: 'archived',
          fileName: 'fileName',
        };

        this.prototype.$allDpActions = ['BK_CANCEL', 'BK_REJECT', 'BK_DONE', 'BK_SEND'];
      }

      $url() {
        return `${super.$url()}/client/${this.clientId}/find/${this.documentType}`;
      }

      $getIds() {
        return this.data.map(blDocument => blDocument.id);
      }

      $delete() {
        return this.$apiCall({
          url: 'document.json/list',
          method: 'DELETE',
          params: {
            ids: this.$getIds().join(),
          },
        }).then(() => this.$destroy());
      }

      $init(data) {
        super.$init();

        // Automatically fetch the first time this collection is created.
        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }

      $serializeMeta(res) {
        return _.pick(res, ['resultsPerPage', 'totalResults']);
      }

      $serialize(res) {
        return super.$serialize(res.results);
      }

      $downloadFiles() {
        return FileModel.downloadList(this.$getIds());
      }

      $downloadFilesAsStatement() {
        return FileModel.downloadListAsStatement(this.$getIds());
      }

      $downloadDpFiles() {
        return FileModel.downloadDpFiles(this.$getIds());
      }

      $dpActions() {
        return _(this.data)
          .map(blDocument => blDocument.getDpActions())
          .reduce((acc, actions) => _.intersection(acc, actions), this.$allDpActions);
      }

      $dpStatus() {
        return this.data.map(blDocument => blDocument.getDpStatus());
      }

      $archive() {
        return this.$apiCall({
          method: 'PUT',
          url: `document.json/client/${this.clientId}/archive`,
          params: {
            ids: this.$getIds().join(),
          },
        }).then(res => {
          _.each(res.data, obj => this.$findById(obj.id).$destroy());
          return res;
        });
      }

      $unarchive() {
        return this.$apiCall({
          method: 'PUT',
          url: `document.json/client/${this.clientId}/unarchive`,
          params: {
            ids: this.$getIds().join(),
          },
        }).then(res => {
          _.each(res.data, obj => this.$findById(obj.id).$destroy());
          return res;
        });
      }

      $updateStatus(action, bkId, bknote = '', hprFlag = false, hprReason = null) {
        return this.$apiCall({
          method: 'PUT',
          url: 'document.json/list/resources/data_processing_metadata',
          data: {
            action,
            bkId,
            note: bknote,
            hprFlag,
            hprReason,
          },
          params: {
            ids: this.$getIds().join(),
          },
        }).then(res => {
          _.each(res.data != null ? res.data.successful : undefined, obj => {
            const blDocument = new Document(obj.id);
            return blDocument.$set(blDocument.$serialize(obj));
          });
          return res;
        });
      }
    };
    DocumentCollection.initClass();
    return DocumentCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [
  require('data/model/document').name,
  require('data/model/file').name,
  require('data/util').name,
];

module.exports = angular
  .module('bench.data.collection.document', moduleDeps)
  .factory('DocumentCollection', factory);
